/**
 * Convert various image URL formats to direct image URLs that load in browsers.
 * Handles Google Drive sharing URLs and other common formats.
 */

const extractDriveFileId = (url) => {
  // Pattern 1: /file/d/FILE_ID/view
  let match = url.match(/\/file\/d\/([a-zA-Z0-9_-]+)/);
  if (match) return match[1];

  // Pattern 2: ?id=FILE_ID or &id=FILE_ID
  match = url.match(/[?&]id=([a-zA-Z0-9_-]+)/);
  if (match) return match[1];

  // Pattern 3: /d/FILE_ID
  match = url.match(/\/d\/([a-zA-Z0-9_-]+)/);
  if (match) return match[1];

  return null;
};

export const getImageUrl = (url, fallback = '') => {
  if (!url || typeof url !== 'string' || !url.trim()) {
    return fallback;
  }

  const trimmed = url.trim();

  // Skip URLs that don't look like URLs (e.g. just "image.png" without scheme)
  if (!/^https?:\/\//i.test(trimmed)) {
    return fallback;
  }

  // Google Drive URLs - convert to lh3.googleusercontent.com format
  // This format works reliably with CORS and doesn't require login
  if (trimmed.includes('drive.google.com') || trimmed.includes('docs.google.com')) {
    const fileId = extractDriveFileId(trimmed);
    if (fileId) {
      return `https://lh3.googleusercontent.com/d/${fileId}=w1600`;
    }
  }

  // Direct URL (Imgur, ImgBB, Cloudinary, Unsplash, etc.)
  return trimmed;
};
